module.exports = __webpack_public_path__ + "img/maestro.9e755d97.svg";